<template>
  <div>
    <table
      class="table table-striped table-sm"
      v-if="orders && orders.length > 0"
    >
      <thead>
        <tr style="width: 100%">
          <th scope="col">
            <input type="checkbox" class="mr-4" v-model="selectAll" />
            <img
              v-if="orders && orders.length > 0"
              class="printer-icon"
              @click="generatePdf"
              src="../../icons/dod/printer.svg"
              alt=""
            />
          </th>
          <th scope="col">Podopieczny</th>
          <th scope="col">Numer telefonu</th>
          <th scope="col">Dni</th>
          <th scope="col">Ilość godz. zaplanowanych</th>
          <th scope="col">Ilość godz. wykonanych</th>
          <th scope="col"></th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in orders" :key="order.id">
          <td>
            <input type="checkbox" v-model="selectedOrdersIds[order.id]" />
          </td>
          <td>{{ order.customer.firstName }} {{ order.customer.lastName }}</td>
          <td>{{ order.customer.phone }}</td>
          <td>{{ getWeekdaysShortNames(order.days) }}</td>
          <td>{{ order.numberOfScheduledHours }}</td>
          <td>{{ order.numberOfMadeHours }}</td>
          <td>
            <gradient-button
              @handleClick="moveToCustomerDetails(order.customer.id)"
              :title="'Przejdź'"
              :customStyles="'width: 118px'"
            />
          </td>
          <td>
            <img
              class="printer-icon"
              @click="deleteOrder(order)"
              src="../../icons/dod/trash.svg"
              alt=""
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import shared from "../../shared";
import GradientButton from "./GradientButton.vue";
export default {
  components: { GradientButton },
  name: "DodEmployeeOrders",
  props: ["employeeId"],
  emits: ["deleteOrder"],
  data() {
    return {
      selectAll: false,
      selectedOrdersIds: {},
    };
  },

  watch: {
    selectAll() {
      this.orders.forEach((order) => {
        this.selectedOrdersIds[order.id] = this.selectAll;
      });
    },
  },

  methods: {
    deleteOrder(order) {
      if (
        confirm(
          ` Czy na pewno chcesz usunąć podopiecznego: ${order.customer.firstName} ${order.customer.lastName}?`
        )
      ) {
        this.$emit("deleteOrder", order);
      }
    },
    getWeekdaysShortNames(orderDays) {
      const daysWithoutDuplicates = [
        ...new Set(orderDays.map((d) => d.dayName)),
      ];
      const dirEn = {
        MONDAY: "PON",
        TUESDAY: "WT",
        WEDNESDAY: "ŚR",
        THURSDAY: "CZW",
        FRIDAY: "PT",
        SATURDAY: "SOB",
        SUNDAY: "ND",
      };

      let daysPl = [];
      Object.entries(dirEn).forEach(([key, value]) => {
        if (daysWithoutDuplicates.includes(key)) {
          daysPl.push(value);
        }
      });

      return daysPl.join(",");
    },

    moveToCustomerDetails(customerId) {
      this.$router.push({
        name: "DodCustomerDetails",
        params: { id: customerId },
      });
    },

    async generatePdf() {
      for (const [key, value] of Object.entries(this.selectedOrdersIds)) {
        if (key && value) {
          await this.handlePrint(key);
        }
      }
    },

    async handlePrint(key) {
      const response = await this.$store.dispatch("generateWorkingCardPdf", {
        orderId: key,
        month: this.employeeFetchParams.ordersMonth,
        year: this.employeeFetchParams.ordersYear,
      });
      const fileURL = window.URL.createObjectURL(new Blob([response]));
      const fileLink = document.createElement("a");
      const monthName = shared.getPolishMonthNameByMonthNumber(
        this.employeeFetchParams.ordersMonth - 1
      );
      const employee = this.orders.find((order) => order.id === key)?.employee;
      const customer = this.orders.find((order) => order.id === key)?.customer;
      const filename = `Karta pracy opiekuna ${employee.firstName} ${
        employee.lastName
      } i podopiecznego ${customer.firstName} ${
        customer.lastName
      } na miesiąc ${monthName.toLowerCase()}.pdf`;

      fileLink.href = fileURL;
      fileLink.setAttribute("download", filename);
      document.body.appendChild(fileLink);
      fileLink.click();
    },
  },

  computed: {
    orders() {
      return this.$store.getters.getDodSelectedEmployeeOrders?.data || [];
    },
    employeeFetchParams() {
      return this.$store.getters.getDodEmployeeFetchParams;
    },
  },
};
</script>

<style  scoped>
.printer-icon {
  cursor: pointer;
}
</style>